import * as React from "react";
const SvgFiRrScaleComparisonAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scale-comparison-alt_svg__a)">
      <path
        fill="#062147"
        d="m19.295 10.406 2.113-2.113a.999.999 0 1 1 1.414 1.414l-2.244 2.244a1.8 1.8 0 0 1-1.284.532h-.01a1.8 1.8 0 0 1-1.288-.545l-1.21-1.234a.999.999 0 1 1 1.428-1.4l1.082 1.103zM2.293 9.707a.997.997 0 0 0 1.414 0l.793-.793.793.793a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L5.914 7.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793-.793-.793a.999.999 0 1 0-1.414 1.414l.793.793-.793.793a1 1 0 0 0 0 1.414M4.5 17C2.26 17 .32 15.234 0 13.036c-.005-.145-.003-.895.55-1.468.25-.259.7-.568 1.424-.568h5.051c.724 0 1.174.309 1.424.568.553.573.555 1.324.55 1.468C8.683 15.235 6.744 17 4.5 17m0-2c1.205 0 2.247-.848 2.484-1.996L2.015 13c.238 1.15 1.281 2 2.485 2M24 16.036C23.684 18.235 21.744 20 19.5 20s-4.18-1.766-4.5-3.964c-.005-.145-.003-.895.55-1.468.25-.259.7-.568 1.424-.568h5.051c.724 0 1.174.309 1.424.568.553.573.556 1.324.551 1.468m-2.015-.032L17.016 16c.238 1.15 1.281 2 2.485 2s2.247-.848 2.484-1.996M19.001 22h-6V5.281l6.757 1.689q.123.03.244.03a1 1 0 0 0 .241-1.97L13 3.219V1a1 1 0 0 0-2 0v1.719L4.243 1.03a1 1 0 1 0-.485 1.941l7.243 1.811v17.219h-6a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scale-comparison-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScaleComparisonAlt;
